import { render } from "./AddressCard.vue?vue&type=template&id=22a9051d&scoped=true"
import script from "./AddressCard.vue?vue&type=script&lang=ts"
export * from "./AddressCard.vue?vue&type=script&lang=ts"

import "./AddressCard.vue?vue&type=style&index=0&id=22a9051d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22a9051d"

export default script